global.menu = [
  { title: "หลัก" },
  { name: "Console", link: "/console", icon: "\uf005", type: "admin,project"},
  { name: "Dashboard", link: "/dashboard", icon: "\uf005", type: "admin,project,customer"},
  { name: "อัพโหลดไฟล์ข้อมูล", link: "/upload-data", icon: "\uf093", type: "project"},
  { name: "รายการค้างชำระ", link: "/outstanding-payments", icon: "\uf15c", type: "project,customer"},
  { name: "รายการประวัติการชำระ", link: "/payment-history", icon: "\uf15c", type: "project,customer"},
  { name: "ลูกค้าโครงการ", link: "/customer", icon: "\uf007", type: "project"},
  // ลูกค้าจัดการทรัพย์ของตัวเอง — ใช้หน้าเดียวกับฝั่งงานขาย แต่ backend จำกัดให้เห็นเฉพาะห้องตัวเอง
  // ★ perm ต้องระบุตรง ๆ เพราะ filterMenu เดาคีย์สิทธิ์จาก link ไม่ได้ (ไม่มีคีย์ project-room-all.read)
  // ★ altLinks = หน้าลูกของเมนูนี้ ให้เมนูยังไฮไลต์ค้าง
  //   ลูกบ้านเข้าเมนูนี้แล้วถูกเด้งไป /project-room-edit ทันที (ห้องตัวเองห้องเดียว) จึงต้องมีหน้านั้นด้วย
  //   (หน้า /project-room-sales ถูกลบแล้ว URL เดิม redirect ไป /project-room-all ดู routes.js)
  { name: "จัดการทรัพย์", link: "/project-room-all", altLinks: ["/project-room-edit"], icon: "\uf00b", type: "customer", perm: "sale-listing.read"},
  { name: "ประวัติการใช้งานระบบ", link: "/logs", icon: "\uf15c", type: "admin"},
  { title: "การตั้งค่า" },
  { name: "ประเภทค่าใช้จ่ายกลาง", link: "/expense-types", icon: "\uf03a", type: "admin"},
  { name: "ผู้ใช้", link: "/user", icon: "\uf4fe", type: "admin"},
  { name: "สิทธิ์ผู้ใช้งาน", link: "/role", icon: "\uf023", type: "admin"},
  { name: "ประกาศแจ้งเตือน", link: "/announcements", icon: "\uf1ea", type: "project"},
  { name: "แบนเนอร์", link: "/banners", icon: "\uf024", type: "project"},
  { name: "ข่าวสาร", link: "/news", icon: "\uf302", type: "project"},
  { name: "เนื้อหาหน้าเว็บขาย", link: "/sale-page-contents", icon: "\uf1ea", type: "admin"},
  { name: "ตั้งค่าเริ่มต้นงบกระแสเงินสด", link: "/setting-cash-flow-report", icon: "\uf0d6", type: "project"},
  { title: "รายงาน" },
  { name: "จัดการกระแสเงินสด", link: "/cash-flow-report", icon: "\uf15c", type: "project"},
  { name: "จัดการรายการเงินสดย่อย", link: "/petty-cash-report", icon: "\uf15c", type: "project"},
  { name: "รายงานแยกประเภท", link: "/categorized-report", icon: "\uf15c", type: "project" },
  
];
// ★ หน้า /role แสดง checkbox เฉพาะคีย์ในลิสต์นี้ (ดู Role.js)
//   คีย์งานขายที่ seed ไว้ใน DB แต่ไม่มี route ตรวจ ถูกถอดออกเพื่อไม่ให้มี checkbox ที่ติ๊กแล้วไม่มีผล
//     sale-listing-logs.create/update/delete (ประวัติเป็น append-only อ่านอย่างเดียว)
//     sale-project-settings.create/delete (มีแค่ GET/PUT)
//     sale-inquiries.create (คำขอสร้างจากหน้าเว็บสาธารณะ ไม่ผ่านสิทธิ์ admin)
//     admin-contacts.* ทั้งหมด (เลิกใช้หน้า "ติดต่อ Admin" แล้ว — ใช้การตั้งค่าการขาย (โครงการ) แทน)
//   เพิ่ม route ใหม่ที่ใช้ checkPermission คีย์ไหน ต้องเพิ่มคีย์นั้นที่นี่ด้วย
global.permission = [
  "upload-data.read",
  "expenses.read",
  "outstanding-payments.read",
  "payment-history.read",
  "customer.read",
  "user.read",
  "bank-accounts.read",
  "expense-types.read",
  "role.read",
  "banners.read",
  "news.read",
  "setting-cash-flow-report.read",
  "cash-flow-report.read",
  "petty-cash-report.read",
  "logs.read",
  "sale-listing.read",
  "sale-inquiries.read",
  "sale-page-contents.read",
  "sale-project-settings.read",
  "sale-listing-logs.read",

  "upload-data.create",
  "expenses.create",
  "outstanding-payments.create",
  "payment-history.create",
  "customer.create",
  "user.create",
  "bank-accounts.create",
  "expense-types.create",
  "role.create",
  "banners.create",
  "news.create",
  "setting-cash-flow-report.create",
  "cash-flow-report.create",
  "petty-cash-report.create",
  "logs.create",
  "sale-listing.create",
  "sale-page-contents.create",

  "upload-data.update",
  "expenses.update",
  "outstanding-payments.update",
  "payment-history.update",
  "customer.update",
  "user.update",
  "bank-accounts.update",
  "expense-types.update",
  "role.update",
  "banners.update",
  "news.update",
  "setting-cash-flow-report.update",
  "cash-flow-report.update",
  "petty-cash-report.update",
  "logs.update",
  "sale-listing.update",
  "sale-inquiries.update",
  "sale-page-contents.update",
  "sale-project-settings.update",

  "upload-data.delete",
  "expenses.delete",
  "outstanding-payments.delete",
  "payment-history.delete",
  "customer.delete",
  "user.delete",
  "bank-accounts.delete",
  "expense-types.delete",
  "role.delete",
  "banners.delete",
  "news.delete",
  "setting-cash-flow-report.delete",
  "cash-flow-report.delete",
  "petty-cash-report.delete",
  "logs.delete",
  "sale-listing.delete",
  "sale-inquiries.delete",
  "sale-page-contents.delete",
];
global.role_name = {
  "upload-data": "อัพโหลดไฟล์ข้อมูล",
  "expenses": "รายการค่าใช้จ่าย",
  "outstanding-payments": "รายการค้างชำระ",
  "payment-history": "รายการประวัติการชำระ",
  "customer": "ลูกค้าโครงการ",
  "bank-accounts": "การตั้งค่า > บัญชีธนาคาร",
  "expense-types": "การตั้งค่า > ประเภทค่าใช้จ่าย",
  "user": "การตั้งค่า > ผู้ดูแลระบบ",
  "role": "การตั้งค่า > สิทธิ์ผู้ใช้งาน",
  "banners": "การตั้งค่า > แบนเนอร์",
  "news": "การตั้งค่า > ข่าวสาร",
  "sale-listing": "ประกาศขาย/ให้เช่าห้อง",
  "sale-inquiries": "คำขอนัดดูห้อง (ผู้ติดต่อ)",
  "sale-page-contents": "เนื้อหาหน้าเว็บขาย (ตั้งค่ากลาง ใช้ร่วมทุกโครงการ)",
  "sale-project-settings": "การตั้งค่า > การตั้งค่าการขาย (โครงการ)",
  "sale-listing-logs": "ประวัติการขาย (ดูอย่างเดียว)",
  "setting-cash-flow-report": "การตั้งค่า > ตั้งค่ารายงานกระแสเงินสดรับ - กระแสเงินสดจ่าย",
  "logs": "ประวัติการใช้งานระบบ",
  "cash-flow-report": "รายงาน > รายงานกระแสเงินสดรับ - กระแสเงินสดจ่าย",
  "petty-cash-report": "รายงาน > รายงานเงินสดย่อย",
};
// จัดกลุ่มแถวในตารางสิทธิ์ผู้ใช้งาน (หน้า /role)
//   menus = key เดียวกับ global.role_name — เมนูที่ไม่ได้ระบุในกลุ่มไหนจะไปรวมท้ายกลุ่ม "อื่น ๆ" อัตโนมัติ
global.role_group = [
  {
    label: "งานนิติบุคคล",
    menus: [
      "upload-data",
      "expenses",
      "outstanding-payments",
      "payment-history",
      "customer",
      "user",
      "bank-accounts",
      "expense-types",
      "role",
      "banners",
      "news",
      "setting-cash-flow-report",
      "cash-flow-report",
      "petty-cash-report",
      "logs",
    ],
  },
  {
    label: "งานขาย",
    menus: [
      "sale-listing",
      "sale-inquiries",
      "sale-page-contents",
      "sale-project-settings",
      "sale-listing-logs",
    ],
  },
];
//   สถานะการโอน
global.status_transfer = {
  0: "",
  1: "โอนกรรมสิทธิ์แล้ว",
  2: "ยังไม่โอนกรรมสิทธิ์",
  3: "ห้องว่าง",
};

// ซื้ออาคารโดย
global.status_buy_building = {
  0: "",
  1: "เงินสด",
  2: "ผ่อนชำระกับธนาคาร",
  3: "ผู้เช่าซื้อกับการเคหะแห่งชาติ",
  4: "ซื้อต่อกับลูกค้าเดิม",
  5: "อื่น ๆ",
};

// ธนาคาร
global.bank = ["ธนาคารกรุงเทพ", 
  "ธนาคารกสิกรไทย", 
  "ธนาคารกรุงไทย", 
  "ธนาคารไทยพาณิชย์", 
  "ธนาคารกรุงศรีอยุธยา", 
  "ธนาคารออมสิน", 
  "ธนาคารทหารไทยธนชาต", 
  "ธนาคารเพื่อการเกษตรและสหกรณ์การเกษตร (ธ.ก.ส.)", 
  "ธนาคารอิสลามแห่งประเทศไทย", 
  "ธนาคารซีไอเอ็มบี ไทย", 
  "ธนาคารยูโอบี", 
  "ธนาคารสแตนดาร์ดชาร์เตอร์ด", 
  "ธนาคารทิสโก้", 
  "ธนาคารเกียรตินาคินภัทร", 
  "ธนาคารแลนด์ แอนด์ เฮ้าส์"];
